export interface Theme {
  name: string;
  properties: any;
}

// Amazon Connect Agent Workspace dark palette
// Colours sourced from the Amazon Connect Agent Workspace dark UI:
// Page bg: #0d1926 | Panel: #192638 | Card/dialog: #1f3040
// Navbar/sidebar: #0d1926 | Border: #2a3f52 | Text: #e8edf1
// Secondary text: #8fafc4 | Accent/CTA: #0972d3 | Input bg: #253347
export const darkTheme: Theme = {
  name: 'darkTheme',
  properties: {
    '--primary-color': '#192638',
    '--primary-light-color': '#1f3040',
    '--primary-dark-color': '#0d1926',

    // Amazon Connect signature blue as the interactive accent
    '--secondary-default-color': '#0972d3',
    '--secondary-light-color': '#539fe5',
    '--secondary-dark-color': '#0558a8',

    '--background-default-color': '#0d1926',
    '--background-light-color': '#192638',
    '--background-dark-color': '#060e17',

    '--navbar': '#0d1926',
    '--on-navbar': '#e8edf1',
    '--navbar-shadow': '0px 2px 8px 0px rgba(0,0,0,0.6)',

    '--sidebar': '#0d1926',
    '--on-sidebar': '#e8edf1',

    '--subnav': '#192638',
    '--on-subnav': '#8fafc4',

    '--btn-ok': '#0972d3',
    '--btn-cancel': '#253347',

    '--conversations-list-item': '#192638',

    '--information-color': '#f0e040',
    '--success-color': '#1d8102',
    '--error-color': '#d13212',
    '--warning-color': '#f89256',

    '--scroll-light-color': 'rgba(143,175,196,0.3)',
    '--scroll-dark-color': 'rgba(143,175,196,0.6)',
    '--grey-light': '#253347',
    '--icon-light-color': '#8fafc4',
    '--icon-light-hover-color': '#b8d0e3',
    '--icon-dark-color': '#b8d0e3',

    '--surface-color': '#192638',
    '--on-surface-color': '#e8edf1',
    '--on-surface-secondary': '#8fafc4',
    '--border-color': '#2a3f52',
    '--input-bg': '#253347',
    '--input-color': '#e8edf1',
    '--card-bg': '#1f3040',
    '--card-header-bg': '#253347',
    '--table-bg': '#192638',
    '--table-stripe-bg': '#1c2d3e',
    '--table-hover-bg': '#253347',
    '--dropdown-bg': '#1f3040',
    '--dropdown-color': '#e8edf1',
    '--dropdown-hover-bg': '#253347',
  },
};

export const defaultTheme: Theme = {
  name: 'parlyTheme',
  properties: {
    '--primary-color': '#455a64',
    '--primary-light-color': '#718792',
    '--primary-dark-color': '#1c313a',

    '--secondary-default-color': '#4dd0e1',
    '--secondary-light-color': '#88ffff',
    '--secondary-dark-color': '#009faf',

    '--background-default-color': 'var(--primary-color)',
    '--background-light-color': '#e1ebf1',
    '--background-dark-color': 'var(--primary-light-color)',

    '--navbar': 'var(--primary-dark-color)',
    '--on-navbar': '#ffffff',
    '--navbar-shadow': '0px 4px 7px 0px rgba(28, 49, 58, 0.2)',

    '--sidebar': 'var(--primary-dark-color)',
    '--on-sidebar': '#ffffff',

    '--subnav': 'var(--background-light-color)',
    '--on-subnav': '#000000',

    '--btn-ok': 'var(--secondary-dark-color)',
    '--btn-cancel': 'var(--primary-dark-color)',

    '--conversations-list-item': 'var(--grey-light)',

    '--information-color': '#faff1a',
    '--success-color': '#44d931',
    '--error-color': '#b00020',
    '--warning-color': '#ffb01f',

    '--scroll-light-color': 'rgba(146, 148, 156, 0.4)',
    '--scroll-dark-color': 'rgba(146, 148, 156, 0.8)',
    '--grey-light': '#f5f5f6',
    '--icon-light-color': '#92929ccc',
    '--icon-light-hover-color': '#707079cc',
    '--icon-dark-color': '#4f4f4f',

    '--surface-color': '#ffffff',
    '--on-surface-color': '#212529',
    '--border-color': '#dee2e6',
    '--input-bg': '#ffffff',
    '--input-color': '#212529',
    '--card-bg': '#ffffff',
    '--card-header-bg': '#f8f9fa',
    '--table-bg': '#ffffff',
    '--table-stripe-bg': '#f8f9fa',
    '--table-hover-bg': '#e9ecef',
    '--dropdown-bg': '#ffffff',
    '--dropdown-color': '#212529',
    '--dropdown-hover-bg': '#f8f9fa',
  },
};

export const engageHubTheme: Theme = {
  name: 'engageHubTheme',
  properties: {
    '--primary-color': '#8CBF5C',
    '--primary-light-color': '#AFD08E',
    '--primary-dark-color': '#2b4d0e',

    '--secondary-default-color': '#4dd0e1', // #2F3740
    '--secondary-light-color': '#414D59',
    '--secondary-dark-color': '#232D38',

    '--background-default-color': '#EAF0F8',
    '--background-light-color': '#EAF0F8',
    '--background-dark-color': '#a9b2bb',

    '--navbar': 'var(--primary-dark-color)', // #ffffff
    '--on-navbar': '#ffffff', // #3C4752
    '--navbar-shadow': '0px 4px 7px 0px rgba(28, 49, 58, 0.2)',

    '--sidebar': '#323d4b',
    '--on-sidebar': '#ffffff',

    '--subnav': '#ffffff',
    '--on-subnav': '#000000',

    '--btn-ok': 'var(--primary-color)',
    '--btn-cancel': '#133853',

    '--conversations-list-item': '#ffffff',

    '--information-color': '#7EBBBE',
    '--success-color': '#44d931',
    '--error-color': '#b00020',
    '--warning-color': '#F6AA44',

    '--scroll-light-color': 'rgba(146, 148, 156, 0.4)',
    '--scroll-dark-color': 'rgba(146, 148, 156, 0.8)',
    '--grey-light': '#f5f5f6',
    '--icon-light-color': '#92929ccc',
    '--icon-light-hover-color': '#707079cc',
    '--icon-dark-color': '#4f4f4f',
  },
};
